/**
 * Format ISO8601 date to DD/MM/YYYY for KDS display.
 * @param {string} isoDateString - ISO8601 datetime with timezone (e.g., "2026-08-04T20:00:00+00:00")
 * @returns {string} Formatted date (e.g., "04/08/2026")
 */
export function formatScheduledDateForKDS(isoDateString) {
  if (!isoDateString) return null;
  const d = new Date(isoDateString);
  if (isNaN(d.getTime())) return null;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}
